import "bootstrap-icons/font/bootstrap-icons.css";
import "./styles/CashlinePersonal.css";

import { LinkButton } from "components/buttons";
import EnquiryForm from "components/forms/EnquiryForm";
import { Jumbotron } from "sections";

import { handleOpenPdf } from "utils";
import { ASSETS_BASE_URL } from "constants";

import Icon from "assets/images/line_icons.svg";
import Benefits from "components/benefits";
import { ShariahItem } from "components/pf";

import Financing from "assets/images/hero-images/Banner_Financing.png";
import BG from "assets/images/hero-images/BG.png";
// import cashline_header from "assets/images/cashline_header.jpg";

function CashlinePersonal() {
  const pfBenefitsData = [
    {
      title: (
        <>
          <b>Attractive rates</b>
        </>
      ),
      content: (
        <p className="benefits-content-text">As low as low as SBR* + 6.50%</p>
      ),
      delay: "100",
    },
    {
      title: (
        <>
          <b>Tenure</b>
        </>
      ),
      content: <p className="benefits-content-text">Up to 8 years.</p>,
      delay: "200",
    },
    {
      title: (
        <>
          <b>Flexible Withdrawal</b>
        </>
      ),
      content: (
        <p className="benefits-content-text">
          via Cheque, Debit Card, Internet Banking, or from any of our branches.
        </p>
      ),
      delay: "300",
    },
    {
      title: (
        <>
          <b>Fee</b>
        </>
      ),
      content: <p className="benefits-content-text">Zero Commitment Fee.</p>,
      delay: "300",
    },
    {
      title: (
        <>
          <b>Collaterals</b>
        </>
      ),
      content: <p className="benefits-content-text">No collaterals needed.</p>,
      delay: "300",
    },
  ];
  const pfBenefitsConfig = {
    heading: "Benefits",
    tnc: "*Terms & Conditions apply",
    // faq: "FAQ",
    benefitsData: pfBenefitsData,
    desktopImages: `${ASSETS_BASE_URL}assets/images/pf/shahrul.svg`,
    mobileImage: `${ASSETS_BASE_URL}assets/images/pf/shahrul.svg`,
    tncLink: "/tnc",
  };

  const pfEligibility = {
    type: "pf",
    title: "Apply easily",
    steps: 2,
    highlightedText: "in just 2 steps",
    documentsTitle: "Required Documents",
    employeeType: "",
    horizontalTable: true,
    yearsOld: "years old",
    documents: [
      {
        title: "<span>Salaried employees</span>",
        content:
          "<ul><li>Photocopy of <b>IC / Identification document</b></li><li>Latest <b>3 months salary slip</b> and <b>personal bank statement</b> reflecting salary crediting</li><li>Latest <b>EPF statement</b></li><li>Sales & <b>Purchase Agreement</b> / Booking receipt</li></ul>",
        backgroundColor: "#DCE9FF",
      },
      {
        title: "<span>Self-employed</span>",
        content:
          "<ul><li>Photocopy of <b>IC / Identification document</b></li><li>Latest <b>6 months bank statement</b></li><li><b>Business Registration Document</b></li><li>Copy of <b>Income Tax</b> & proof of tax payment</li><li>Sales & <b>Purchase Agreement</b> / Booking receipt</li></ul>",
        backgroundColor: "#F2F4F7",
      },
    ],
    eligibilityTitle: "Eligibility",
    eligibility: [
      {
        title:
          "<ul><li><strong>Malaysians and non-Malaysians (T&C apply)</strong></li></ul>",
        content:
          "<ul><li><strong>Individual aged 21 years & up to 65 years)</strong></li></ul>",
        backgroundColor: "#DCE9FF",
      },
    ],
  };

  const pfFeesAndCharges = {
    type: "pf",
    title: "Fees & Charges",
    documents: [
      {
        title: "Retrieval / Photocopy of Security Documents",
        content: "Actual Cost",
      },
      {
        title: "EPF Withdrawal Confirmation Letter Fee",
        content: "RM10.00 per request",
      },
      {
        title: "Annual Financing Statement Fee",
        content: "RM 5.00 per request (Ad-hoc)",
      },
      {
        title: "Redemption Statement Fee",
        content: "RM 10.00 per request",
      },
      {
        title: "Brokerage Fee",
        content: "0.0008% of the principal amount of financing/disbursement",
      },
      {
        title: "ARNT Fee (or Agency Fee)",
        content: "RM 1.00 per transaction",
      },
    ],
    buttons: [
      {
        title: "Product Disclosure Sheet",
        link: `${ASSETS_BASE_URL}assets/pdf/personal-financing/PDS%20-%20Retail%20Cashline-i%20(1).pdf`,
      },
      {
        title: "Download Application Form",
        link: `${ASSETS_BASE_URL}assets/pdf/personal-financing/HF_Application_Form.pdf `,
      },
    ],
  };

  const FaqListPFHome = [
    {
      id: 0,
      title: "What is the Shariah contract applicable?",
      content: "The applicable Shariah contract is Commodity Murabahah.",
    },
    {
      id: 1,
      title: "What is the minimum and maximum tenure?",
      content:
        "The financing tenure is ranging from minimum 5 years up to 35 years, subject to terms and conditions.",
    },
    {
      id: 2,
      title: "What is the minimum and maximum financing amount?",
      content: "The Minimum financing amount is RM50,000.",
    },
    {
      id: 3,
      title: "Is Mortgage Reducing Term Takaful (MRTT) coverage compulsory?",
      content:
        "The Mortgage Reducing Term Takaful (MRTT) coverage is optional.",
    },
    {
      id: 4,
      title:
        "<span>How to apply Home <span className='no-wrap'>Financing-<i>i</i> ?</span></span>",
      content:
        "<p>You may walk-in to the nearest branch, or contact our call centre at +603 2332 6000, or share your contact details in this link <a className='no-wrap' href='https://www.alrajhibank.com.my/enquiry'>Product Enquiry</a> , our bank representative will contact to assist you.</p>",
    },
    {
      id: 5,
      title: "How do I pay for the monthly installment?",
      content:
        "You are required to deposit the monthly instalment in your financing account on or before its due date until the full settlement of the financing.",
    },
    {
      id: 6,
      title: "What if I fully settle the financing before its maturity?",
      content:
        "<p>You may opt to fully settle the financing prior to the maturity date. If the facility is settled within first 5 years from the date of the first disbursement, the Bank shall have the right to claim actual entry costs (if any).</p><p>Rebate will be granted by the Bank in accordance with Bank Negara Malaysia Guidelines and our internal rebate (Ibra’) guideline.</p><p>The customer may at any time after the completion of each Sale transaction pay the entire amount of the Bank Sale price or any part thereof then owing to the Bank as the Bank may in absolute discretion accept.</p>",
    },
    {
      id: 7,
      title: "How do I contact alrajhi bank Malaysia?",
      content:
        "<p>For more information, kindly contact one of our 24-Hour Customer Care Consultants using your preferred method below:</p><p>+603 2332 6000</p><p>customersupport@alrajhibank.com.my</p>",
    },
  ];

  return (
    <div>
      <section className="section jumbotron">
        <Jumbotron
          badgeText="Property Financing-i"
          title={`<span className="jumbotron-subtitle-2">Cashline</span><em>-i</em>`}
          buttonText="Let's connect!"
          backgroundImage={Financing}
          uniqueBg={BG}
        />
      </section>

      <section className="section about container">
        <div className="row pf-page" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3 className="general-header">About</h3>
          </div>
          <div className="col-xl-8">
            <p className="about-text">
              alrajhi bank Malaysia offers Cashline-<em>i</em>, a
              Shariah-compliant flexible financial solution to help you better
              manage your finances. With Cashline-<em>i</em>, you can access
              cash anytime you need it. This financing option allows you to
              easily draw, pay, and redraw funds from the Current Account-
              <em>i</em> (CA-<em>i</em>) you hold with alrajhi bank Malaysia, up
              to the approved limit. Enjoy the convenience of Cashline-
              <em>i</em> and stay financially flexible with us.
            </p>
          </div>
        </div>
      </section>
      <Benefits {...pfBenefitsConfig} />

      <section className="section about container">
        <ShariahItem
          header={<span>Shariah Contract</span>}
          subheader="Commodity Murabahah (via Tawarruq arrangement)"
          Icon={Icon}
        />
      </section>

      <section className="section about container">
        <div className="eligibility-title" data-aos="slide-right">
          Eligibility
        </div>
        <div class="eligibility-card">
          <div class="eligibility-header">Eligibility</div>
          <div class="eligibility-content">
            <div class="eligibility-section" data-aos="fade-down">
              <div>
                <span class="eligibility-age">25 </span>
                <span class="eligibility-years">years old</span>
              </div>
              <hr class="eligibility-line"></hr>
              <div class="eligibility-label">Minimum age</div>
            </div>
            <div
              class="eligibility-section"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              <div class="eligibility-income">RM15,000 &amp; above</div>
              <div class="eligibility-income-label">
                of minimum monthly income
              </div>
            </div>
          </div>
        </div>
        <div className="link-button-row pt-sm-5 m-sm-5 mb-sm-0 justify-content-center">
          <div className="m-2">
            <LinkButton
              text={"Cashline-i Application Form"}
              onClick={() => handleOpenPdf(`${ASSETS_BASE_URL}assets/pdf/personal-financing/Cashline-i%20Application%20Form.pdf`)}
            />
          </div>
          <div className="m-2">
            <LinkButton
              text={"Product Disclosure Sheet"}
              onClick={() => handleOpenPdf(`${ASSETS_BASE_URL}assets/pdf/personal-financing/Cashline%20CIB%20-%20PDS.pdf`)}
            />
          </div>
        </div>
      </section>
      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4 d-xl-block d-none">
            <h3>Let's connect!</h3>
            <p>
              Share your information, and we'll get back to you with the answers
              you need.
            </p>
          </div>
          <div className="col-xl-8">
            <EnquiryForm />
          </div>
        </div>
      </section>
    </div>
  );
}

export default CashlinePersonal;
